import type { FC } from 'react'

import { unit } from '@hcr/ui'
import { isNotUndefined, isUndefined } from '@hcr/utils'

import { useHoliday } from '../../contexts'
import { useDestinationDetailsQuery } from '../../hooks'
import { createDestinationDetailsContent } from '../../utils'
import { BookingOverviewCompact, LayoutNavigationError500 } from '../common'

import { LayoutHome } from './common'
import { HomeDestination } from './HomeDestination'
import { HomeEmpty } from './HomeEmpty'
import { HomeFallback } from './HomeFallback'
import { HomeLoading } from './HomeLoading'

const destinationDetailsContent = createDestinationDetailsContent({ slidesMargin: unit(3) })

export const Home: FC = () => {
  const {
    data: { accommodation, destination },
    ...holiday
  } = useHoliday()

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(destination?.destinationId) },
    { enabled: isNotUndefined(destination) }
  )

  if (holiday.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (destinationDetails.isError) {
    return <HomeFallback />
  }

  if (holiday.isSuccess && isUndefined(accommodation) && isUndefined(destination)) {
    return <HomeEmpty />
  }

  if (holiday.isSuccess && isUndefined(accommodation)) {
    return <HomeDestination />
  }

  if (holiday.isSuccess && destinationDetails.isSuccess) {
    return (
      <LayoutHome
        imageUrl={destinationDetails.data.imageUrl}
        header={<BookingOverviewCompact />}
        content={destinationDetails.data.content.map(destinationDetailsContent)}
      />
    )
  }

  return <HomeLoading />
}
